import React from 'react';
import styled from '@emotion/styled';
import ReportHeader from './components/Header';
import Table from 'app/components/Table';
import { getColumnDef } from './constants';
import { useNavigate } from 'react-router';
import { JOB_STATUS } from 'app/components/Status/JobStatus';
import { get } from 'lodash';
import classes from './Report.module.scss';

const Container = styled.div`
  background: #fff;
  padding: 24px;
`;
const StyledTable = styled(Table)`
  margin-top: 16px;

  .ant-table-empty {
    .ant-table-cell {
      border-bottom: 0;
    }
  }

  .ant-table-row-expand-icon-cell,
  .ant-table-expand-icon-col {
    display: none !important;
  }
`;
const Reports = (props: {
  poItems: Array<any[]>;
  reportId: number | string;
  status: string;
}) => {
  const conlumDefs = getColumnDef();
  const navigate = useNavigate();
  const defaultExpandKeys = props.poItems?.map((item: any) => item.id);

  const onViewReport = () => {
    navigate(`/dashboard/inspection/job/${props.reportId}/report`);
  };

  const hideViewReport = React.useMemo(() => {
    return [
      JOB_STATUS.pendingAssign,
      JOB_STATUS.waitingAccept,
      JOB_STATUS.scheduled,
      JOB_STATUS.scheduledReject
    ].includes(get(JOB_STATUS, props.status, ''));
  }, [props.status]);

  return (
    <Container className={classes.report}>
      <ReportHeader
        hideViewReport={hideViewReport}
        onViewReport={onViewReport}
      ></ReportHeader>
      {defaultExpandKeys.length > 0 && (
        <StyledTable
          className={classes.table}
          scroll={{ x: '90%' }}
          tableLayout="auto"
          rowKey={(record: any) => record.id}
          pagination={false}
          dataSource={props.poItems}
          columns={conlumDefs}
          expandable={{
            expandedRowClassName: () => classes.expandedRow,
            expandedRowRender: (record) => {
              return (
                <Table
                  className={classes.subTable}
                  pagination={false}
                  dataSource={record.inspectionSubPOItems}
                  columns={[
                    {
                      title: 'PO #',
                      dataIndex: 'poNo',
                      width: '20%'
                    },
                    {
                      title: 'PO Qty',
                      dataIndex: 'orderQty',
                      width: '20%'
                    },
                    {
                      title: 'PO # of Cartons',
                      dataIndex: 'cartonsNo',
                      width: '20%'
                    },
                    {
                      title: 'Customer Name',
                      dataIndex: 'clientName',
                      width: '20%'
                    },
                    {
                      title: 'Customer PO#',
                      dataIndex: 'clientPONo',
                      width: '20%'
                    }
                  ]}
                ></Table>
              );
            },
            rowExpandable: () => true,
            defaultExpandedRowKeys: defaultExpandKeys,
            expandIcon: () => null
          }}
        ></StyledTable>
      )}
    </Container>
  );
};

export default Reports;
